import { useState } from 'react';
import { FormControl, FormLabel, Box, Stack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    dropDownFormStyle,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const ALL_AVAILABLE_OPTION = { id: null, name: 'All Available' };

const EngineLocations = ({
    darkMode,
    errors,
    engineLocations = [],
    isLoadingEngineLocations,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const {
        formData,
        updateFormData,
        engineLocationsError,
        setEngineLocationsError,
    } = useCompanyForm();

    const selected = Array.isArray(formData[FORM_FIELD_PATHS.ENGINE_LOCATIONS])
        ? formData[FORM_FIELD_PATHS.ENGINE_LOCATIONS]
        : [];

    const handleChange = (items) => {
        const realItems = (items || []).filter((item) => item.id);
        updateFormData(FORM_FIELD_PATHS.ENGINE_LOCATIONS, realItems);
    };

    const hasError =
        !!errors?.[FORM_FIELD_PATHS.ENGINE_LOCATIONS] || !!engineLocationsError;

    const clearBackendError = () => {
        if (engineLocationsError) {
            setEngineLocationsError(null);
        }
    };

    return (
        <FormControl
            sx={{ margin: '0 !important', paddingBottom: 2 }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Data Processing Region
                </FormLabel>
                <Box flex={1} maxWidth="400px" pt="15px">
                    <Select
                        isMulti
                        selectedOptionColor="brand"
                        value={
                            selected.length ? selected : [ALL_AVAILABLE_OPTION]
                        }
                        options={engineLocations}
                        getOptionLabel={(item) => item.name}
                        getOptionValue={(item) => item.id}
                        isClearable={!!selected.length}
                        isLoading={isLoadingEngineLocations}
                        placeholder="Select data processing region"
                        closeMenuOnSelect={false}
                        tagVariant="solid"
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        chakraStyles={dropDownFormStyle(darkMode, true)}
                        components={
                            selected.length
                                ? undefined
                                : { MultiValueRemove: () => null }
                        }
                        onChange={handleChange}
                        onFocus={clearBackendError}
                        onMenuOpen={clearBackendError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the data processing region(s) for this company"
                        ariaLabel="data-processing-region-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default EngineLocations;
